<ngx-spinner type="line-scale-party">
  <div class="spinner">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <h1>Carregando</h1>
</ngx-spinner>
